/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const verifyLoginCodeRequestV4Schema = z.object({
  pendingToken: z
    .string()
    .nullish()
    .describe('The `pendingToken` returned by `auth/login` when `codeRequired` was true.'),
  code: z.string().nullish().describe('The 6-digit code from the email.'),
  rememberDevice: z
    .boolean()
    .optional()
    .describe('True = remember this browser: logins from it skip the code for 60 days.'),
})
